<template>
  <div class="container">

    <br>
    <div class="jumbotron">
    <h1 class="display-4">Formularios</h1>
    <p class="lead">Lista de formulários</p>
    <hr class="my-4">
   <div class="row">
    <div class="col">
      <table class="table table-condensed table-ligth">
        <thead>
          <tr>
              <th>
                #
              </th>
              <th>
                Título
              </th>
              <th>Status</th>
              <th>
                &nbsp;
              </th>
              <th>
                Resultado
              </th>

              <th style="text-align:center">
                Exportar
              </th>

          </tr>
        </thead>
        <tbody>
            <tr :key="index" v-for="(formulario, index) in formularios">
            <td>{{formulario.formularioId}}</td>
             <td>{{formulario.titulo}}</td>
              <td>
                <span v-if="formulario.ativo" class="badge badge-success">Ativo</span>
                <span  v-if="!formulario.ativo" class="badge badge-danger">Encerrado</span>
              </td>
            <td>
              <router-link :to="{path: `/responder-formulario/${formulario.formularioId}`}">
               <button :disabled="!formulario.ativo"  :class="{'btn-success': formulario.ativo, 'btn-outline-success': !formulario.ativo}" class="btn btn-sm">Responder</button>
              </router-link>
            </td>
              <td>
              <router-link target="_blank" :to="{path: `/apuracao/parcial/${formulario.formularioId}`}">
               <button  class="btn btn-outline-info btn-sm">Resultado</button>
              </router-link>

            </td>
            <td style="text-align:center">
              <div class="custom-control custom-checkbox">
                <input v-model="formulariosExportar" :value="formulario" type="checkbox" class="custom-control-input" :id="(`${index}_chkExportar`)">
                <label class="custom-control-label" :for="(`${index}_chkExportar`)"></label>
              </div>
            </td>
            </tr>
        </tbody>
        <tfoot>
          <tr>
            <td colspan="5">&nbsp;</td>
            <td style="text-align:center">
              <button :disabled="selecionouResultado==false" @click="exportarDados" class="btn btn-success btn-sm">Expor.Excel</button>
            </td>
          </tr>

        </tfoot>
      </table>
    </div>
  </div>
    </div>

  </div>
</template>

<script>

import FormularioService from '../services/FormularioService'
import relatorioService from '../services/Relatorio.service'
export default {
  name: 'GerenciarFormulario',
  data () {
    return {
      formularios: [],
      formulariosExportar: []
    }
  },
  methods: {
    exportarDados () {
      this.formulariosExportar.forEach(formulario => {
        // preparar o nome do relatotorio
        let nome = `${formulario.titulo}_${new Date().getTime()}`
        nome = nome.replace(/\s/gm, '_')

        FormularioService.gerarDadosRelatorioFormulario(formulario.formularioId).then(result => {          
          relatorioService.exportarParaExcel(nome, result.data)
        })
      })
    }
  },
  async mounted () {
    this.formularios = await FormularioService.obterFormularios()
  },
  created () {
  },
  computed: {
    selecionouResultado () {
      return this.formulariosExportar && this.formulariosExportar.length > 0
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/View/GerenciarFormularioPage.vue